// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".clear[data-v-ed1eb982],\n.register[data-v-ed1eb982] {\n  width: 8em;\n}", ""]);
// Exports
module.exports = exports;
